import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reusable Card component with coffee-themed styling
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.hover - Enable hover effects
 * @param {string} props.variant - Card variant: 'default', 'gradient', 'bordered'
 * @param {Object} props.animation - Framer Motion animation props
 */
const Card = ({
  children,
  className = '',
  hover = true,
  variant = 'default',
  animation = {},
  ...props
}) => {
  const baseClasses = 'rounded-xl p-6 transition-all duration-300';
  
  const variantClasses = {
    default: 'bg-white shadow-lg border border-coffee-100',
    gradient: 'bg-gradient-to-br from-cream-50 to-coffee-50 shadow-lg border border-coffee-200',
    bordered: 'bg-white border-2 border-coffee-300 shadow-md'
  };
  
  const hoverClasses = hover ? 'hover:shadow-xl hover:-translate-y-1' : '';
  
  const cardClasses = `${baseClasses} ${variantClasses[variant]} ${hoverClasses} ${className}`;
  
  const defaultAnimation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };
  
  const finalAnimation = { ...defaultAnimation, ...animation };
  
  return (
    <motion.div
      className={cardClasses}
      {...finalAnimation}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Card;